
export const countryList = [{displayLabel: 'Afghanistan', value: 'AF'},
    {displayLabel: 'Aland Islands', value: 'AX'},
    {displayLabel: 'Albania', value: 'AL'},
    {displayLabel: 'Algeria', value: 'DZ'},
    {displayLabel: 'Andorra', value: 'AD'},
    {displayLabel: 'Angola', value: 'AO'},
    {displayLabel: 'Anguilla', value: 'AI'},
    {displayLabel: 'Antarctica', value: 'AQ'},
    {displayLabel: 'Antigua and Barbuda', value: 'AG'},
    {displayLabel: 'Argentina', value: 'AR'},
    {displayLabel: 'Armenia', value: 'AM'},
    {displayLabel: 'Aruba', value: 'AW'},
    {displayLabel: 'Australia', value: 'AU'},
    {displayLabel: 'Austria', value: 'AT'},
    {displayLabel: 'Azerbaijan', value: 'AZ'},
    {displayLabel: 'Bahamas', value: 'BS'},
    {displayLabel: 'Bahrain', value: 'BH'},
    {displayLabel: 'Bangladesh', value: 'BD'},
    {displayLabel: 'Barbados', value: 'BB'},
    {displayLabel: 'Belarus', value: 'BY'},
    {displayLabel: 'Belgium', value: 'BE'},
    {displayLabel: 'Belize', value: 'BZ'},
    {displayLabel: 'Benin', value: 'BJ'},
    {displayLabel: 'Bermuda', value: 'BM'},
    {displayLabel: 'Bhutan', value: 'BT'},
    {displayLabel: 'Bolivia, Plurinational State of', value: 'BO'},
    {displayLabel: 'Bonaire, Sint Eustatius and Saba', value: 'BQ'},
    {displayLabel: 'Bosnia and Herzegovina', value: 'BA'},
    {displayLabel: 'Botswana', value: 'BW'},
    {displayLabel: 'Bouvet Island', value: 'BV'},
    {displayLabel: 'Brazil', value: 'BR'},
    {displayLabel: 'British Indian Ocean Territory', value: 'IO'},
    {displayLabel: 'Brunei Darussalam', value: 'BN'},
    {displayLabel: 'Bulgaria', value: 'BG'},
    {displayLabel: 'Burkina Faso', value: 'BF'},
    {displayLabel: 'Burundi', value: 'BI'},
    {displayLabel: 'Cambodia', value: 'KH'},
    {displayLabel: 'Cameroon', value: 'CM'},
    {displayLabel: 'Canada', value: 'CA'},
    {displayLabel: 'Cape Verde', value: 'CV'},
    {displayLabel: 'Cayman Islands', value: 'KY'},
    {displayLabel: 'Central African Republic', value: 'CF'},
    {displayLabel: 'Chad', value: 'TD'},
    {displayLabel: 'Chile', value: 'CL'},
    {displayLabel: 'China', value: 'CN'},
    {displayLabel: 'Chinese Taipei', value: 'TW'},
    {displayLabel: 'Christmas Island', value: 'CX'},
    {displayLabel: 'Cocos (Keeling) Islands', value: 'CC'},
    {displayLabel: 'Colombia', value: 'CO'},
    {displayLabel: 'Comoros', value: 'KM'},
    {displayLabel: 'Congo', value: 'CG'},
    {displayLabel: 'Congo, the Democratic Republic of the', value: 'CD'},
    {displayLabel: 'Cook Islands', value: 'CK'},
    {displayLabel: 'Costa Rica', value: 'CR'},
    {displayLabel: 'Cote d\'Ivoire', value: 'CI'},
    {displayLabel: 'Croatia', value: 'HR'},
    {displayLabel: 'Cuba', value: 'CU'},
    {displayLabel: 'Curaçao', value: 'CW'},
    {displayLabel: 'Cyprus', value: 'CY'},
    {displayLabel: 'Czech Republic', value: 'CZ'},
    {displayLabel: 'Denmark', value: 'DK'},
    {displayLabel: 'Djibouti', value: 'DJ'},
    {displayLabel: 'Dominica', value: 'DM'},
    {displayLabel: 'Dominican Republic', value: 'DO'},
    {displayLabel: 'Ecuador', value: 'EC'},
    {displayLabel: 'Egypt', value: 'EG'},
    {displayLabel: 'El Salvador', value: 'SV'},
    {displayLabel: 'Equatorial Guinea', value: 'GQ'},
    {displayLabel: 'Eritrea', value: 'ER'},
    {displayLabel: 'Estonia', value: 'EE'},
    {displayLabel: 'Ethiopia', value: 'ET'},
    {displayLabel: 'Falkland Islands (Malvinas)', value: 'FK'},
    {displayLabel: 'Faroe Islands', value: 'FO'},
    {displayLabel: 'Fiji', value: 'FJ'},
    {displayLabel: 'Finland', value: 'FI'},
    {displayLabel: 'France', value: 'FR'},
    {displayLabel: 'French Guiana', value: 'GF'},
    {displayLabel: 'French Polynesia', value: 'PF'},
    {displayLabel: 'French Southern Territories', value: 'TF'},
    {displayLabel: 'Gabon', value: 'GA'},
    {displayLabel: 'Gambia', value: 'GM'},
    {displayLabel: 'Georgia', value: 'GE'},
    {displayLabel: 'Germany', value: 'DE'},
    {displayLabel: 'Ghana', value: 'GH'},
    {displayLabel: 'Gibraltar', value: 'GI'},
    {displayLabel: 'Greece', value: 'GR'},
    {displayLabel: 'Greenland', value: 'GL'},
    {displayLabel: 'Grenada', value: 'GD'},
    {displayLabel: 'Guadeloupe', value: 'GP'},
    {displayLabel: 'Guatemala', value: 'GT'},
    {displayLabel: 'Guernsey', value: 'GG'},
    {displayLabel: 'Guinea', value: 'GN'},
    {displayLabel: 'Guinea-Bissau', value: 'GW'},
    {displayLabel: 'Guyana', value: 'GY'},
    {displayLabel: 'Haiti', value: 'HT'},
    {displayLabel: 'Heard Island and McDonald Islands', value: 'HM'},
    {displayLabel: 'Holy See (Vatican City State)', value: 'VA'},
    {displayLabel: 'Honduras', value: 'HN'},
    {displayLabel: 'Hong Kong', value: 'HK'},
    {displayLabel: 'Hungary', value: 'HU'},
    {displayLabel: 'Iceland', value: 'IS'},
    {displayLabel: 'India', value: 'IN'},
    {displayLabel: 'Indonesia', value: 'ID'},
    {displayLabel: 'Iran, Islamic Republic of', value: 'IR'},
    {displayLabel: 'Iraq', value: 'IQ'},
    {displayLabel: 'Ireland', value: 'IE'},
    {displayLabel: 'Isle of Man', value: 'IM'},
    {displayLabel: 'Israel', value: 'IL'},
    {displayLabel: 'Italy', value: 'IT'},
    {displayLabel: 'Jamaica', value: 'JM'},
    {displayLabel: 'Japan', value: 'JP'},
    {displayLabel: 'Jersey', value: 'JE'},
    {displayLabel: 'Jordan', value: 'JO'},
    {displayLabel: 'Kazakhstan', value: 'KZ'},
    {displayLabel: 'Kenya', value: 'KE'},
    {displayLabel: 'Kiribati', value: 'KI'},
    {displayLabel: 'Korea, Republic of', value: 'KR'},
    {displayLabel: 'Kuwait', value: 'KW'},
    {displayLabel: 'Kyrgyzstan', value: 'KG'},
    {displayLabel: 'Lao People\'s Democratic Republic', value: 'LA'},
    {displayLabel: 'Latvia', value: 'LV'},
    {displayLabel: 'Lebanon', value: 'LB'},
    {displayLabel: 'Lesotho', value: 'LS'},
    {displayLabel: 'Liberia', value: 'LR'},
    {displayLabel: 'Libyan Arab Jamahiriya', value: 'LY'},
    {displayLabel: 'Liechtenstein', value: 'LI'},
    {displayLabel: 'Lithuania', value: 'LT'},
    {displayLabel: 'Luxembourg', value: 'LU'},
    {displayLabel: 'Macao', value: 'MO'},
    {displayLabel: 'Macedonia, the former Yugoslav Republic of', value: 'MK'},
    {displayLabel: 'Madagascar', value: 'MG'},
    {displayLabel: 'Malawi', value: 'MW'},
    {displayLabel: 'Malaysia', value: 'MY'},
    {displayLabel: 'Maldives', value: 'MV'},
    {displayLabel: 'Mali', value: 'ML'},
    {displayLabel: 'Malta', value: 'MT'},
    {displayLabel: 'Martinique', value: 'MQ'},
    {displayLabel: 'Mauritania', value: 'MR'},
    {displayLabel: 'Mauritius', value: 'MU'},
    {displayLabel: 'Mayotte', value: 'YT'},
    {displayLabel: 'Mexico', value: 'MX'},
    {displayLabel: 'Moldova, Republic of', value: 'MD'},
    {displayLabel: 'Monaco', value: 'MC'},
    {displayLabel: 'Mongolia', value: 'MN'},
    {displayLabel: 'Montenegro', value: 'ME'},
    {displayLabel: 'Montserrat', value: 'MS'},
    {displayLabel: 'Morocco', value: 'MA'},
    {displayLabel: 'Mozambique', value: 'MZ'},
    {displayLabel: 'Myanmar', value: 'MM'},
    {displayLabel: 'Namibia', value: 'NA'},
    {displayLabel: 'Nauru', value: 'NR'},
    {displayLabel: 'Nepal', value: 'NP'},
    {displayLabel: 'Netherlands', value: 'NL'},
    {displayLabel: 'New Caledonia', value: 'NC'},
    {displayLabel: 'New Zealand', value: 'NZ'},
    {displayLabel: 'Nicaragua', value: 'NI'},
    {displayLabel: 'Niger', value: 'NE'},
    {displayLabel: 'Nigeria', value: 'NG'},
    {displayLabel: 'Niue', value: 'NU'},
    {displayLabel: 'Norfolk Island', value: 'NF'},
    {displayLabel: 'Norway', value: 'NO'},
    {displayLabel: 'Oman', value: 'OM'},
    {displayLabel: 'Pakistan', value: 'PK'},
    {displayLabel: 'Palestinian Territory, Occupied', value: 'PS'},
    {displayLabel: 'Panama', value: 'PA'},
    {displayLabel: 'Papua New Guinea', value: 'PG'},
    {displayLabel: 'Paraguay', value: 'PY'},
    {displayLabel: 'Peru', value: 'PE'},
    {displayLabel: 'Philippines', value: 'PH'},
    {displayLabel: 'Pitcairn', value: 'PN'},
    {displayLabel: 'Poland', value: 'PL'},
    {displayLabel: 'Portugal', value: 'PT'},
    {displayLabel: 'Qatar', value: 'QA'},
    {displayLabel: 'Reunion', value: 'RE'},
    {displayLabel: 'Romania', value: 'RO'},
    {displayLabel: 'Russian Federation', value: 'RU'},
    {displayLabel: 'Rwanda', value: 'RW'},
    {displayLabel: 'Saint Barthélemy', value: 'BL'},
    {displayLabel: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH'},
    {displayLabel: 'Saint Kitts and Nevis', value: 'KN'},
    {displayLabel: 'Saint Lucia', value: 'LC'},
    {displayLabel: 'Saint Martin (French part)', value: 'MF'},
    {displayLabel: 'Saint Pierre and Miquelon', value: 'PM'},
    {displayLabel: 'Saint Vincent and the Grenadines', value: 'VC'},
    {displayLabel: 'Samoa', value: 'WS'},
    {displayLabel: 'San Marino', value: 'SM'},
    {displayLabel: 'Sao Tome and Principe', value: 'ST'},
    {displayLabel: 'Saudi Arabia', value: 'SA'},
    {displayLabel: 'Senegal', value: 'SN'},
    {displayLabel: 'Serbia', value: 'RS'},
    {displayLabel: 'Seychelles', value: 'SC'},
    {displayLabel: 'Sierra Leone', value: 'SL'},
    {displayLabel: 'Singapore', value: 'SG'},
    {displayLabel: 'Sint Maarten (Dutch part)', value: 'SX'},
    {displayLabel: 'Slovakia', value: 'SK'},
    {displayLabel: 'Slovenia', value: 'SI'},
    {displayLabel: 'Solomon Islands', value: 'SB'},
    {displayLabel: 'Somalia', value: 'SO'},
    {displayLabel: 'South Africa', value: 'ZA'},
    {displayLabel: 'South Georgia and the South Sandwich Islands', value: 'GS'},
    {displayLabel: 'South Sudan', value: 'SS'},
    {displayLabel: 'Spain', value: 'ES'},
    {displayLabel: 'Sri Lanka', value: 'LK'},
    {displayLabel: 'Sudan', value: 'SD'},
    {displayLabel: 'Suriname', value: 'SR'},
    {displayLabel: 'Svalbard and Jan Mayen', value: 'SJ'},
    {displayLabel: 'Swaziland', value: 'SZ'},
    {displayLabel: 'Sweden', value: 'SE'},
    {displayLabel: 'Switzerland', value: 'CH'},
    {displayLabel: 'Syrian Arab Republic', value: 'SY'},
    {displayLabel: 'Tajikistan', value: 'TJ'},
    {displayLabel: 'Tanzania, United Republic of', value: 'TZ'},
    {displayLabel: 'Thailand', value: 'TH'},
    {displayLabel: 'Timor-Leste', value: 'TL'},
    {displayLabel: 'Togo', value: 'TG'},
    {displayLabel: 'Tokelau', value: 'TK'},
    {displayLabel: 'Tonga', value: 'TO'},
    {displayLabel: 'Trinidad and Tobago', value: 'TT'},
    {displayLabel: 'Tunisia', value: 'TN'},
    {displayLabel: 'Turkey', value: 'TR'},
    {displayLabel: 'Turkmenistan', value: 'TM'},
    {displayLabel: 'Turks and Caicos Islands', value: 'TC'},
    {displayLabel: 'Tuvalu', value: 'TV'},
    {displayLabel: 'Uganda', value: 'UG'},
    {displayLabel: 'Ukraine', value: 'UA'},
    {displayLabel: 'United Arab Emirates', value: 'AE'},
    {displayLabel: 'United Kingdom', value: 'GB'},
    {displayLabel: 'United States', value: 'US'},
    {displayLabel: 'Uruguay', value: 'UY'},
    {displayLabel: 'Uzbekistan', value: 'UZ'},
    {displayLabel: 'Vanuatu', value: 'VU'},
    {displayLabel: 'Venezuela, Bolivarian Republic of', value: 'VE'},
    {displayLabel: 'Vietnam', value: 'VN'},
    {displayLabel: 'Virgin Islands, British', value: 'VG'},
    {displayLabel: 'Wallis and Futuna', value: 'WF'},
    {displayLabel: 'Western Sahara', value: 'EH'},
    {displayLabel: 'Yemen', value: 'YE'},
    {displayLabel: 'Zambia', value: 'ZM'},
    {displayLabel: 'Zimbabwe', value: 'ZW'},
];